export const LogoMark = ({ className = "h-8 w-auto" }) => (
  <svg viewBox="0 0 120 48" className={className} aria-hidden="true">
    <polygon
      points="60,4 116,44 4,44"
      fill="#E85A4F"
      stroke="#0B1B3D"
      strokeWidth="5"
      strokeLinejoin="round"
    />
    <line x1="60" y1="4" x2="60" y2="44" stroke="#0B1B3D" strokeWidth="5" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark className="h-9 w-auto" />
    <span className="flex flex-col leading-none">
      <span
        className={`font-serif text-xl font-bold tracking-[0.08em] ${
          dark ? "text-white" : "text-navy"
        }`}
      >
        GREGORY
      </span>
      <span className="mt-1 flex items-center gap-2">
        <span className="h-px w-4 bg-salmon" />
        <span
          className={`font-serif text-sm font-semibold tracking-[0.4em] ${
            dark ? "text-white/80" : "text-navy/80"
          }`}
        >
          TILE
        </span>
        <span className="h-px w-4 bg-salmon" />
      </span>
    </span>
  </span>
);
